export const LocStrings: any = {
    "en-us":  {
                  "CheckoutError":  "Something went wrong. Checkout not completed."
              }
};
